var React = require('react');

function VideoIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.video-icon-svg{fill-rule:evenodd;clip-rule:evenodd;fill:#3C3C3C;}\n"),React.createElement("path",{"className":"video-icon-svg","d":"M13,7l-3-1.8V6v1v1H2H0V6V2V0h2h6h2v2v0.8L13,1V7z M8,2H2v4h6V2z","key":1})]);
}

VideoIcon.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 13 7.9","style":{"enableBackground":"new 0 0 13 7.9"}};

module.exports = VideoIcon;

VideoIcon.default = VideoIcon;
